export {
  CarCollections as default,
  getStaticProps,
} from '@cinch-nx/feature-car-collections'
